// import Swiper from 'swiper/bundle';
// import Swiper styles
// import 'swiper/css/bundle';
// window.Swiper = Swiper


import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()



/*********************************************************************
	Sliders
 *********************************************************************/


/*
	swiper slider home test
*/

var swiper_home = new Swiper('.swiper-home', {
	loop: true,
	autoHeight: true,
	grabCursor: true,
	autoplay: {
		delay: 6000,
		disableOnInteraction: true,
	},
	pagination: {
		el: '.swiper-pagination',
	},
});


